var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgLike = function SvgLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,21h-3v12h3V21z M12.5,20.02V33h17.54l4.46-10.81v-3.18c-6.37,0-9.88,0-10.54-0.01 c-0.99-0.01-2.08-0.28-2.86-1.32c-0.78-1.04-0.71-2.1-0.47-3.04l1.61-5.51c0.09-0.36-0.29-0.73-0.6-0.95l-0.45-0.35 C15.67,15.58,12.77,19.64,12.5,20.02z M24.37,15.29h10.76c1.86,0,3.36,1.5,3.36,3.34v3.51c0,0.44-0.09,0.87-0.25,1.27l-5.21,12.55 C32.78,36.59,32.17,37,31.49,37H3.18c-0.93,0-1.68-0.75-1.68-1.67v-16.7c0-0.92,0.75-1.67,1.68-1.67h5.86 c0.55,0,1.06-0.26,1.37-0.71l9.17-12.9c0.24-0.34,0.69-0.45,1.06-0.27L23.7,4.6c1.77,0.88,2.68,2.86,2.19,4.76L24.37,15.29z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })));
};
export default SvgLike;